// @ts-nocheck
import restrictedProductsToggleReducer, {
    StoreRestrictedProductsToggleDataActions,
} from "@store/Framework/Store/Data/RestrictedProductsToggle/RestrictedProductsToggleReducer";
import StoreListDetailsReducer, {
    StoreListsDetailsDataActions,
} from "@store/Framework/Store/Data/StoreListDetails/StoreListDetailsReducer";
import StoreListsReducer, { StoreListsDataActions } from "@store/Framework/Store/Data/StoreLists/StoreListsReducer";
import { combineReducers } from "redux";

const dataReducers = {
    storeLists: StoreListsReducer,
    storeListDetails: StoreListDetailsReducer,
    restrictedProductsToggle: restrictedProductsToggleReducer,
};

export type StoreDataActions =
    | StoreListsDataActions
    | StoreListsDetailsDataActions
    | StoreRestrictedProductsToggleDataActions;

const dataReducer = combineReducers(dataReducers as any);
export default dataReducer;
